import React, { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import axios from 'axios'; // We will use axios for making API requests
import { API_URL } from '../../constants/api';
import { decodeToken, getToken } from '../../utils/TokenUtils';

const ResetPassword = () => {
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const { token } = useParams();
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  //console.log('reset token:', token);

  const id = decodeToken(token, 'id');
  // console.log('id:', id);

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Simple validation for demo purposes
    if (!newPassword || !confirmPassword) {
      setError('Both fields are required.');
      return;
    }

    try {
      // API call to login
      const response = await axios.post(
        `${API_URL}/api/users/reset-password`,
        {
          newPassword,
          confirmPassword,
        },
        {
          headers: {
            Authorization: token ? `Bearer ${token}` : '',
          },
        }
      );
      // console.log('response:', response.data);
      if (response.data.success === 1) {
        setSuccess(response.data.message);
        setError(null);
      } else {
        setError(response.data.message);
        setSuccess(null);
      }

      // Redirect to the dashboard
      // navigate('/dashboard');
    } catch (error) {
      // Handle error (e.g., invalid credentials)
      console.log('error:', error.message);
      setError('Invalid email or password');
    }
  };

  return (
    <div className="container d-flex justify-content-center align-items-center min-vh-100">
      <div className="col-md-4 p-4 border rounded shadow-lg bg-light">
        <h2 className="text-center mb-4">Reset Password</h2>

        {error && <div className="alert alert-danger">{error}</div>}
        {success && <div className="alert alert-success">{success}</div>}

        <form onSubmit={handleSubmit}>
          <div className="mb-3">
            <label htmlFor="password" className="form-label">
              New Password
            </label>
            <input
              type="password"
              className="form-control"
              id="password"
              placeholder="Enter your new password"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              required
            />
          </div>

          <div className="mb-3">
            <label htmlFor="password" className="form-label">
              Confirm Password
            </label>
            <input
              type="password"
              className="form-control"
              id="password"
              placeholder="Enter your password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              required
            />
          </div>

          <div className="d-flex justify-content-between align-items-center">
            <button type="submit" className="btn btn-primary">
              Reset Password
            </button>
            <a href="/login" className="text-decoration-none">
              Login
            </a>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ResetPassword;
